export type QuotationProgressStep =
  | 'validating_link'
  | 'searching_store'
  | 'detecting_category'
  | 'calculating_weight'
  | 'calculating_shipping';

/** Datos parciales que el backend ya resolvió al completar un paso (ver
 *  QuotationProgressData en el ms de marketplace). Todos opcionales: solo
 *  vienen los campos que ese paso realmente aportó. */
export interface QuotationProgressData {
  name?: string | null;
  image_mask?: string | null;
  image_exist?: boolean;
  price?: number | null;
  weight?: number | null;
  category_backend_name?: string | null;
  category_frontend_name?: string | null;
  store?: string | null;
  is_ready_to_buy?: boolean;
}

export type QuotationProgressEvent =
  | { type: 'step'; step: QuotationProgressStep; data?: QuotationProgressData }
  | { type: 'done'; data: unknown }
  | { type: 'error'; message: string };

// Orden real del backend: el Lambda de IA (openai-assistant) clasifica primero la
// categoría y usa esa categoría para acotar el rango de peso esperado antes de
// calcularlo (ver AIAssistantService.getInfo: classifyProduct → fetchWeight).
export const QUOTATION_PROGRESS_STEPS: QuotationProgressStep[] = [
  'validating_link',
  'searching_store',
  'detecting_category',
  'calculating_weight',
  'calculating_shipping',
];

export const QUOTATION_STEP_LABELS: Record<QuotationProgressStep, string> = {
  validating_link: 'Validando el enlace de tu producto',
  searching_store: 'Buscando tu producto en la tienda',
  calculating_weight: 'Calculando el peso de tu producto',
  detecting_category: 'Detectando la categoría de tu producto',
  calculating_shipping: 'Calculando el costo de envío',
};

/** Una cotización SSE en curso, identificada por un id efímero: un uuid nuevo
 *  para productos que aún no existen en el carrito, o el `cart_uid` real
 *  cuando se está re-cotizando un producto ya agregado (botón "Actualizar precio"). */
export interface QuotationInFlight {
  id: string;
  url: string;
  completedSteps: QuotationProgressStep[];
  partial: QuotationProgressData;
}
